(ns guidebook.views.alignment
  (:require
   [guidebook.common :as gc :refer [format-date title-s body-s format-date]]
   [very.re-frame.core :as rf :refer [>evt]]
   [util.core :as util :refer [valid-date?]]
   [cljss.core :as cljss]
   [css.vars :as vars]
   [css.core
    :refer [get-theme]
    :refer-macros [defstyled]]))

(defstyled alignment-s :div
  {:display "grid"
   :padding "150px 100px"
   :grid-column-gap "180px"
   :grid-row-gap "100px"
   :grid-template-columns "1fr 390px"
   ::cljss/media {[:print]
                  {:display "flex"
                   :flex-direction "column"
                   :width "100%"
                   :padding "82px 100px"}}})

(defstyled header-s :div
  {:grid-column "span 2"})

(defstyled graph-container-s :div
  {:position "relative"
   :margin-top "180px"})

(defstyled explain-s :div
  {:display "flex"
   :align-items "flex-end"
   :flex-direction "column"})

(defstyled graph-labels-s :div
  {:display "grid"
   :grid-template-columns "1fr 1fr 1fr"
   :margin "2rem 0"})

(defstyled graph-label-s :h3
  {:text-transform "uppercase"
   :text-align "center"
   :font-size "24px"
   :color vars/gray})

(defstyled alignment-information-s :div
  {:display "grid"
   :grid-template-columns "max-content max-content"
   :justify-content "space-between"})

(defstyled risk-s :div
  {:display "flex"
   :align-items "flex-end"
   :flex-direction "column"})

(defstyled priorities-s :div
  {})

(defstyled risk-value-s :div
  {:font-size "50px"
   :color vars/black
   :font-weight "300"
   :margin-bottom "30px"})

(defstyled risk-label-s :div
  {:font-size "18px"
   :color vars/gray})

(defstyled priorities-ul-s :ul
  {:list-style-type "disc"
   :font-size "25px"
   :margin-left "25px"})

(defstyled priority-li-s :li
  {:color vars/jellybean
   :margin-bottom "15px"})

(defstyled overlap-center-s :div
  {:display "grid"
   :justify-content "center"
   :grid-template-columns "1fr 1fr"})

(defstyled aligned-s :div
  {:position "absolute"
   :top "-200px"
   :bottom "-20px"
   :width "calc(33.333% + 3px)"
   :left (with-meta #(cond
                       (= % "left") "0"
                       (= % "middle") "33.333%"
                       (= % "right") "66.666%") :location)
   :border (str "3px dotted " vars/border-light)
   :&:before {:content "Your Status: ALIGNED"
              :display "block"
              :position "absolute"
              :top "-45px"
              :font-size "24px"
              :width "100%"
              :text-align "center"
              :color vars/gray}})

(defn show-circle-normal [{:keys [current target color label]}]
  (let [target-loc (* target 10)]
    (if (> target-loc 80)
      (when (= current 80)
        [gc/score-location-s
         [gc/score-label-s label]
         [gc/score-marker-circle-s
          [gc/score-value-s {:color color} target [gc/score-symbol-s "%"]]]
         [gc/score-marker-arrow-s]])
      (when (= current target-loc)
        [gc/score-location-s
         [gc/score-label-s label]
         [gc/score-marker-circle-s
          [gc/score-value-s {:color color} target [gc/score-symbol-s "%"]]]
         [gc/score-marker-arrow-s]]))))

(defn build-circle-normal [{:keys [current target label]}]
  [gc/score-wrapper-s
   (cond
     (and (< (* 10 target) 28)
          (>= (* 10 target) 0)) [show-circle-normal {:current current
                                                     :target target
                                                     :label label
                                                     :color "#21b3a3"}]
     (< (* 10 target) 55) [show-circle-normal {:current current
                                               :target target
                                               :label label
                                               :color "#f9bc50"}]
     (>= (* 10 target) 55) [show-circle-normal {:current current
                                                :target target
                                                :label label
                                                :color "#d75e25"}])])

(defn show-circles-overlap [{:keys [current target return-value family-value color]}]
  (let [target-loc (* target 10)
        left-value (cond
                     (< return-value family-value) return-value
                     (< family-value return-value) family-value
                     :else family-value)
        right-value (cond
                      (> return-value family-value) return-value
                      (> family-value return-value) family-value
                      :else return-value)
        left-label (if (< return-value family-value)
                     "Anticipated Annual Return"
                     "Family Index Number")
        right-label (if (> family-value return-value)
                      "Family Index Number"
                      "Anticipated Annual Return")]
    (if (> target-loc 80)
      (when (= current 80)
        [overlap-center-s
         [gc/score-location-s {:margin "0 -10px 0 0"}
          [gc/score-label-s left-label]
          [gc/score-marker-circle-s
           [gc/score-value-s {:color color
                              :overlap? true} left-value [gc/score-symbol-s {:overlap? true} "%"]]]]
         [gc/score-location-s {:margin "0 0 0 -10px"}
          [gc/score-label-s right-label]
          [gc/score-marker-circle-s
           [gc/score-value-s {:color color
                              :overlap? true} right-value [gc/score-symbol-s {:overlap? true} "%"]]]]]
        [gc/score-marker-arrow-s {:grid-column "span 2"}])
      (when (= current target-loc)
        [overlap-center-s
         [gc/score-location-s {:margin "0 -10px 0 0"}
          [gc/score-label-s left-label]
          [gc/score-marker-circle-s
           [gc/score-value-s {:color color
                              :overlap? true} left-value [gc/score-symbol-s {:overlap? true} "%"]]]]
         [gc/score-location-s {:margin "0 0 0 -10px"}
          [gc/score-label-s right-label]
          [gc/score-marker-circle-s
           [gc/score-value-s {:color color
                              :overlap? true} right-value [gc/score-symbol-s {:overlap? true} "%"]]]]
         [gc/score-marker-arrow-s {:grid-column "span 2"}]]))))

(defn build-circle-overlap [{:keys [current target return-value family-value]}]
  [gc/score-wrapper-s
   (cond
     (< (* 10 target) 28) [show-circles-overlap {:current current
                                                 :target target
                                                 :return-value return-value
                                                 :family-value family-value
                                                 :color "#21b3a3"}]
     (< (* 10 target) 55) [show-circles-overlap {:current current
                                                 :target target
                                                 :return-value return-value
                                                 :family-value family-value
                                                 :color "#f9bc50"}]
     :else [show-circles-overlap {:current current
                                  :target target
                                  :return-value return-value
                                  :family-value family-value
                                  :color "#d75e25"}])])

(defn show-risk [score]
  (cond
    (< score 11) [risk-value-s "Conservative"]
    (< score 21) [risk-value-s "Moderate"]
    :else [risk-value-s "Growth"]))

(defn show-alignment [annual-return score]
  (cond
    (and (< score 11) (< annual-return 2.8)) [aligned-s {:location "left"}]
    (and (< score 21) (< annual-return 5.5)) [aligned-s {:location "middle"}]
    (and (> score 20) (> annual-return 5.4)) [aligned-s {:location "right"}]))

(defn main []
  (let [alignment (rf/subscribe [:guidebook/alignment])
        risk-profile (rf/subscribe [:guidebook/most-recent-risk-profile])]
    (fn []
      (let [{:keys [expected-annual-return family-index-number priority-names]} @alignment
            score (:score @risk-profile)
            updated-date (:created-at @risk-profile)
            rounded-annual-return (util/round-to 1 expected-annual-return)
            rounded-family-index (util/round-to 1 family-index-number)]
        [alignment-s
         [header-s
          [title-s "Alignment"]]
         [graph-container-s
          (if (and (< (- rounded-annual-return rounded-family-index) 0.8)
                   (> (- rounded-annual-return rounded-family-index) -0.8))
            ; Circles will overlap on graph
            (into [gc/return-s] (map #(build-circle-overlap {:current %
                                                             :target (util/round-to 0 (/ (+ rounded-family-index rounded-annual-return) 2))
                                                             :return-value rounded-annual-return
                                                             :family-value rounded-family-index}) (range 1 81)))
            ; No overlap
            [:div
             (into [gc/return-s] (map #(build-circle-normal {:current %
                                                             :target rounded-annual-return
                                                             :label "Anticipated Annual Return"}) (range 1 81)))
             (into [gc/return-s] (map #(build-circle-normal {:current %
                                                             :target rounded-family-index
                                                             :label "Family Index Number"}) (range 1 81)))])

          [gc/score-gradient-s]
          [graph-labels-s
           [graph-label-s "Conservative"]
           [graph-label-s "Moderate"]
           [graph-label-s "Growth"]]
          [gc/score-gradient-s {:margin-bottom "0"}]
          (into [gc/score-s] (map #(gc/build-score {:current %
                                                    :target score
                                                    :bottom? true}) (range 1 31)))
          [show-alignment expected-annual-return score]]
         [explain-s
          [gc/h1 {:text-align "right"
                  :width "315px"} "What is a Family Index Number?"]
          [gc/text {:text-align "right"} "Your Family Index Number is the rate of return you need to achieve your defined financial priorities."]
          [gc/text {:text-align "right"} "The goal is to have your Anticipated Annual Return equal to or above Your Family Index Number."]]
         [alignment-information-s
          [priorities-s
           [gc/h2 "Your financial priorities"]
           [priorities-ul-s
            (for [p priority-names]
              ^{:key (random-uuid)}
              [priority-li-s
               [gc/text p]])]]
          [risk-s
           [gc/h2 "Your risk profile"]
           [show-risk score]
           [risk-label-s (str "Based on risk score of " score
                              (when (valid-date? updated-date)
                                (str " as of " (format-date updated-date))))]]]]))))
